import React, { useState, useEffect, useContext } from "react";
import axios from 'axios'
import DataTable from 'react-data-table-component';

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Offcanvas from 'react-bootstrap/Offcanvas'

import './App.css';
import { Pencil, PencilFill, X } from "react-bootstrap-icons";

const CLIENTES_UPDATE_API = HOST + '/api/inv/cliente/update/'
const CLIENTES_CANCEL_API = HOST + '/api/inv/cliente/remove/'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const DATE_FORMAT = new Intl.DateTimeFormat('es', { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit', timeZone: (Intl.DateTimeFormat().resolvedOptions().timeZone) })

function Clientes() {
  const { setGlobalLoading, formDataToJson, setMailBody, setMailTitle, setShowMesage, setCallback, getNombreEstado, getClientes, showMesage, estadosList, callback, clientesList, rol } = useContext(GlobalContext);

  const [ removeId, setRemoveId ] = useState(null)

  const [ show, setShow ] = useState(false)
  const [ showDesc, setShowDesc ] = useState(false)
  const [ action, setAction ] = useState('Crear Proveedor')

  const [ idCliente, setIdCliente ] = useState({ })
  const [ razonSocial, setRazonSocial ] = useState(null)
  const [ rfc, setRfc ] = useState(null)
  const [ calle, setCalle ] = useState(0)
  const [ numeroInt, setNumeroInt ] = useState(null)
  const [ numeroExt, setNumeroExt ] = useState(null)
  const [ colonia, setColonia ] = useState(null)
  const [ idEstado, setIdEstado ] = useState(null)
  const [ pais, setPais ] = useState('México')
  const [ contacto, setContacto ] = useState(null)
  const [ email, setEmail ] = useState(null)
  const [ telefono, setTelefono ] = useState(null)
  const [ cp, setCp ] = useState(null)
  const [ estatus, setEstatus ] = useState(null)

  useEffect(() => {
    setGlobalLoading( true )
    getClientes()
  }, []);

  useEffect(() => {
    if( showMesage && callback)
      cancelProveedor()
  }, [ callback ]);

  const showForm = (item, desc) => {

    if( item ){
      setAction('Actualizar Cliente')
      setIdCliente(item.idCliente)
      setRazonSocial(item.razonSocial)

      setRfc( item.rfc )
      setCalle( item.calle )
      setNumeroInt( item.numeroInt )
      setNumeroExt( item.numeroExt )
      setColonia( item.colonia )
      setIdEstado( item.idEstado )
      setPais( item.pais )
      setContacto( item.contacto )
      setEmail( item.email )
      setTelefono( item.telefono )
      setCp( item.cp )
      setEstatus( item.estatus )

    } else {
      setAction('Nuevo Cliente')
      setIdCliente(null)
      setRazonSocial(null)

      setRfc( null )
      setCalle( null )
      setNumeroInt( null )
      setNumeroExt( null )
      setColonia( null )
      setIdEstado( null )
      setPais( 'México' )
      setContacto( null )
      setEmail( null )
      setTelefono( null )
      setCp( null )
      setEstatus( null )
    }

    if(desc) setShowDesc(true)
    else setShow(true)
  }

  const updateItem = (e) => {
    e.preventDefault();
    setGlobalLoading( true )
    var form = document.getElementById('driveForm');
		var formData = new FormData(form);
    formData.append('estatus', true);

    var json = formDataToJson(formData)

    console.log('json to update proveedores', json)

    axios.post(CLIENTES_UPDATE_API, json, {
			headers: { 'content-type': 'application/json' }
    }).then(result => {
      console.log("result update", result.data)
      setShow(false)
      getClientes()
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  const cancelProveedorMsg = (id) => {
    setRemoveId(id)
    setShowMesage(true)
    setMailTitle('Remover Cliente')
    setMailBody('¿Seguro que desea remover al Cliente? Esta acción podria impactar a la operación.')
  }

  const cancelProveedor = () => {
    setGlobalLoading( true )

    axios.post(CLIENTES_CANCEL_API, removeId, {
      headers: { 'content-type': 'application/json' }
    }).then(result => {
      console.log("result cancel", result.data)
      setShowMesage(false)
      getClientes()
      setGlobalLoading( false )
      setCallback(false)
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setGlobalLoading( false )
    })
  }

  /**************************************** Data Table ****************************************/

  const [filterText, setFilterText] = useState('');
	const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const columns = [
    {
      name: <th>Razón Social</th>,
      selector: row => <div className="item-link" onClick={ () => showForm(row, true) }> 
        { row.razonSocial } 
      </div>,
      sortable: true,
    },
    {
      name: <th>RFC</th>,
      selector: row => row.rfc,
      sortable: true,
    },
    {
      name: <th>Contacto</th>,
      selector: row => row.contacto,
      sortable: true,
    },
    {
      name: <th>Email</th>,
      selector: row => row.email,
      sortable: true,
    },
    {
      name: <th>Estado</th>,
      selector: row => <div className={ row.estatus ? 'status-ok-icon' : 'status-cancel-icon' }></div>,
      sortable: true,
    },
    {
      cell: row => 
      <>
        <PencilFill onClick={ () => showForm(row) } className="table-icon" /> &nbsp;
        {  row.estatus && 
          <> <X onClick={ () => cancelProveedorMsg(row.idCliente) } className="table-icon" /> </>
        }
      </>,
    },
  ];

  useEffect(() => {
    if( clientesList.length > 0) {
      let data = []

      if(filterText && filterText !== '' ) {
        data = clientesList.filter(
          item => item.razonSocial && item.razonSocial.toLowerCase().includes(filterText.toLowerCase()),
        )
      } else data = clientesList

      console.log("data filtered", data)
      setFilteredItems(data);
    }
  }, [ clientesList, filterText ]);

  /**************************************** Data Table ****************************************/

  return (
    <>
      <Offcanvas show={showDesc} onHide={ () => setShowDesc(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ razonSocial }</div>
            <div className="desc-form">{ 'RFC: ' + rfc }</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Container>
            <Row>
              <div>
                <Container>
                  <Row>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Calle </div>
                      <div>{ calle }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Número Interior </div>
                      <div>{ numeroInt }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Número Exterior </div>
                      <div>{ numeroExt }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Colonia </div>
                      <div>{ colonia }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Estado </div>
                      <div>{ idEstado ? getNombreEstado(idEstado).estado : '' }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> C.P. </div>
                      <div>{ cp }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> País </div>
                      <div>{ pais }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Contacto </div>
                      <div>{ contacto }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Email </div>
                      <div>{ email }</div>
                    </Col>
                    <Col md="6" className='mb-3'>
                      <div className="desc-form"> Teléfono </div>
                      <div>{ telefono }</div>
                    </Col>
                  </Row>
                </Container>
                
                <br/>
                <div align="center">
                  { parseInt(rol) === 2 && 
                    <>
                      <button type="button" onClick={ () => { setShowDesc(false); setShow(true); } } className="grl-btn"> <Pencil />&nbsp;&nbsp;Editar </button>
                    </>
                  }
                </div>
              </div>
            </Row>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={show} onHide={ () => setShow(false) } placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="title-form">{ action }</div>
            <div className="desc-form"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form id="driveForm" onSubmit={ updateItem }>
            <Container>
              <Row>
                <div>
                  <input type="hidden" name="idCliente" value={ idCliente } />
                  <Container>
                    <Row>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Razón Social">
                            <Form.Control required name="razonSocial" value={ razonSocial } onChange={ (e) => setRazonSocial( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="RFC">
                            <Form.Control required name="rfc" value={ rfc } onChange={ (e) => setRfc( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>

                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Calle">
                            <Form.Control required name="calle" value={ calle } onChange={ (e) => setCalle( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Número Int.">
                            <Form.Control required name="numeroInt" value={ numeroInt } onChange={ (e) => setNumeroInt( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Número Ext.">
                            <Form.Control name="numeroExt" value={ numeroExt } onChange={ (e) => setNumeroExt( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Colonia">
                            <Form.Control required name="colonia" value={ colonia } onChange={ (e) => setColonia( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Estado">
                            <Form.Select required name="idEstado" value={ idEstado } onChange={ (e) => setIdEstado( e.target.value ) }>
                              <option>Selecciona una opción</option>
                              { estadosList.map( item => (
                                <option key={ item.idEstado } value={ item.idEstado }>{ item.estado }</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="C.P.">
                            <Form.Control required name="cp" value={ cp } onChange={ (e) => setCp( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="País">
                            <input type="hidden" name="pais" value={ 'México' } />
                            <Form.Control required disabled value={ pais } onChange={ (e) => setPais( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Contácto">
                            <Form.Control required name="contacto" value={ contacto } onChange={ (e) => setContacto( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Email">
                            <Form.Control required name="email" value={ email } onChange={ (e) => setEmail( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group className='mb-3'>
                          <FloatingLabel label="Teléfono">
                            <Form.Control required name="telefono" value={ telefono } onChange={ (e) => setTelefono( e.target.value ) } placeholder="" />
                          </FloatingLabel>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Container>
                  
                  <br/>
                  <div align="center">
                    <button type="button" className="cancel-btn" onClick={ () => setShow(false) } >{ 'Cancelar' }</button>&nbsp;&nbsp;
                    <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                  </div>
                </div>
              </Row>
            </Container>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Container className='main-component'>
        <Row>
          <Col md={ 9 }>
            <div className="section-subtitle"> Lista de Clientes </div>
            <br/>
          </Col>
          <Col md={ 3 } align="right">
            { parseInt(rol) === 2 && <div className="single-btn" onClick={ () => showForm() } > Nuevo </div> }
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Group className='mb-3'>
              <FloatingLabel label="Buscar">
                <Form.Control id="search" value={filterText} onChange={ (e) => setFilterText(e.target.value) } placeholder="" />
              </FloatingLabel>
            </Form.Group>
            { filteredItems.length > 0 && 
              <>
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                  persistTableHead
                />
              </>
            }
            { filteredItems.length === 0 && 
              <div>Sin registros</div>
            }
          </Col>
        </Row>
      </Container>

    </>
  );
}

export default Clientes;
